import { create } from 'zustand';

/**
 * Lightweight Zustand store for keyboard focus state.
 *
 * Isolated from the selection store so:
 *  - Focus changes don't trigger selection-subscriber re-renders.
 *  - Selection changes don't trigger focus-subscriber re-renders.
 *
 * fieldType is stored alongside focusedId so multiple grids on the same page
 * don't interfere with each other.
 *
 * Not persisted — keyboard focus is ephemeral and should reset on page load.
 */
export const useKeyboardFocusStore = create( ( set ) => ( {
	fieldType: null,
	focusedId: null,
	hasFocus:  false,

	setFocusedId( fieldType, focusedId ) {
		set( { fieldType, focusedId, hasFocus: true } );
	},

	setHasFocus( hasFocus ) {
		// Avoid notifying subscribers when the value hasn't changed
		set( ( s ) => s.hasFocus === hasFocus ? s : { ...s, hasFocus } );
	},
} ) );
